import React from "react";

export default function Orders() {
  return (
    <div>
      <img src="https://static.vecteezy.com/system/resources/previews/001/970/338/original/building-under-construction-site-free-vector.jpg" />
    </div>
  );
}
